<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap>
      <v-flex md6 sm12 xs12  v-for="(stat, index) in statObjects" :key="stat.key">
        <v-card>
          <v-container
            fluid
            grid-list-lg
            wrap
          >
            <v-layout row wrap>
              <v-flex xs12 style="padding: 8px">
                <v-card :color="colorValue(index)" class="white--text text-xs-center">
                  <v-card-title primary-title class="text-xs-center">
                    <div style="width: 100%" >
                      <div class="title-sized text-uppercase">{{stat.key}}</div>
                      <span class="super-sized"><router-link :to="stat.link" style="color: white;">{{ stat.value }}</router-link></span>
                    </div>
                  </v-card-title>
                  <!--<v-card-actions>
                    <v-btn flat dark>Listen now</v-btn>
                  </v-card-actions>-->
                </v-card>
              </v-flex>

            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import http from "../http";
import { baseApiUrl } from "../config";
const colors = [
  'blue darken-3',
  'green darken-4',
  'blue-grey accent-4',
  'grey darken-4',
  'blue darken-4',
  'green darken-3',
  'blue-grey accent-3',
  'grey accent-3',
  'blue darken-2',
  'green darken-2',
  'blue-grey accent-2',
  'grey accent-2',
];

export default {
  name: "Dashboard",
  data() {
    return {
      stats: undefined
    };
  },
  components: {
  },
  computed: {
    statObjects() {
      if (!this.stats) return;

      return Object.keys(this.stats).map((s) => { return { key: s, ...this.stats[s] } });
    }
  },
  methods: {
    colorValue(i) {
      return colors[i];
    }
  },
  
  async beforeCreate() {
    const dashboardResults = await http.get(`${baseApiUrl}/dashboard/stats`);
    
    console.log('Got dashboardResults:', dashboardResults);

    const stats = {
        'ECO Check Pending': {
          value: dashboardResults.data.ecoCheckPendingSerialCount,
          link: '/serial-updates?ecoStatus=Pending',
        },
        'Items In Testing': {
          value: dashboardResults.data.itemsInTestingCount,
          link: '/serial-updates?testingStatus=In+Process',
        },
        'Items to Fulfill': {
          value: dashboardResults.data.itemsToFulfillCount,
          link: '/serial-updates?requestStatus=Approved+for+Fulfillment',
        },
        'Pending Invoice': {
          value: dashboardResults.data.invoicePendingCount,
          link: '/serial-updates?invoiceStatus=Pending',
        },								
      };

    this.stats = stats;
  },

  mounted() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'Dashboard', disabled: true },
    ]);
  },
};
</script>

<style>
.remove-top-padding {
  padding-top: 0px;
  padding-bottom: 24px;
  padding-left: 24px;
  padding-right: 24px;
}

.spacer {
  margin-top: 12px;
}

.super-sized {
  font-size: 96pt;
}

.title-sized {
  font-size: 22pt;
}
</style>
